import { initTitleMarks, observeTitleMarks } from 'ia-util-title-mark';

/**
 * PLP title marks.
 *
 * Filter AJAX replaces `.collection__products` innerHTML (new #MainProductGrid).
 * Load-more appends cards into the grid. Both need a fresh measure pass — a
 * one-shot reference to the initial grid goes stale after filters update.
 */

const productsRoot = document.querySelector(
  '#MainCollectionGrid .collection__products'
);

let boundGrid = null;
let stopResizeObserve = null;
let stopLoadMoreObserve = null;

function getGrid() {
  return document.getElementById('MainProductGrid');
}

function applyTitleMarks() {
  const grid = getGrid();
  if (!grid) return;
  initTitleMarks(grid);
}

function scheduleTitleMarks() {
  requestAnimationFrame(() => requestAnimationFrame(applyTitleMarks));
  if (document.fonts?.ready) {
    document.fonts.ready.then(applyTitleMarks);
  } else {
    applyTitleMarks();
  }
}

function bindGridObservers() {
  const grid = getGrid();
  if (!grid) return;

  // Same grid instance — keep existing observers.
  if (grid === boundGrid) return;

  boundGrid = grid;
  stopResizeObserve?.();
  stopLoadMoreObserve?.();

  stopResizeObserve = observeTitleMarks(grid, applyTitleMarks);

  const loadMoreObserver = new MutationObserver(() => {
    scheduleTitleMarks();
  });
  loadMoreObserver.observe(grid, { childList: true });
  stopLoadMoreObserve = () => loadMoreObserver.disconnect();
}

function onProductsUpdated() {
  bindGridObservers();
  scheduleTitleMarks();
}

if (getGrid() || productsRoot) {
  onProductsUpdated();

  // Filters swap the grid as a direct child of `.collection__products`.
  if (productsRoot) {
    new MutationObserver(() => {
      onProductsUpdated();
    }).observe(productsRoot, { childList: true });
  }

  document.addEventListener('collection:products-updated', onProductsUpdated);
}
